<template>
	<div>
		<div class="topTitle">总运营数据监测</div>
		<div class="first_line">
			<div class="right_warp">
				  <span class="demonstration">年份</span>
				    <el-date-picker
				      v-model="filter.month"
				      type="year"
				      placeholder="选择年"
					  value-format="yyyy"
					  size="small"
					   @change="getlist()" >
				    </el-date-picker>
				<el-button type="primary" style=" position: relative;margin-left: 10px" @click="getlist()" size="small">筛 选</el-button>
			</div>
			<el-button type="info" style="dispaly:flex;float:right" size="small" @click="expro()">导出</el-button>
		</div>
		<div>
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="month" label="年份"></el-table-column>
				<el-table-column prop="storeNum" label="门店数"></el-table-column>
				<el-table-column prop="totalIncome" label="总营收"></el-table-column>
				<el-table-column prop="newCustomer" label="新客数"></el-table-column>
				<el-table-column prop="meituanCustomer" label="美团单数"></el-table-column>
				<el-table-column prop="douyinCustomer" label="抖音单数"></el-table-column>
				<el-table-column prop="totalCustomer" label="总客数"></el-table-column>
				<el-table-column prop="taocanCustomer" label="套餐数"></el-table-column>
				<el-table-column prop="taocanIncome" label="套餐营收"></el-table-column>
				<el-table-column prop="haircutCustomer" label="剪发单数"></el-table-column>
				<el-table-column prop="colorCustomer" label="染护单数"></el-table-column>
				<el-table-column prop="colorInAll" label="染护占比">
					<template slot-scope="scope">
						{{scope.row.colorInAll==0?"0":(scope.row.colorInAll*100).toFixed(2)}}%
					</template>
				</el-table-column>
				<el-table-column prop="chengben" label="总成本">
					<template slot-scope="scope">
						{{scope.row.chengben==null?"0":scope.row.chengben}}
					</template>
				</el-table-column>
				<el-table-column prop="yingli" label="利润">
					<template slot-scope="scope">
						<span v-if="scope.row.yingli>0" style="color:limegreen">
							{{scope.row.yingli}}
						</span>
						<span v-else style="color:red">
							{{scope.row.yingli==null?"0":scope.row.yingli}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="lilv" label="净利率">
					<template slot-scope="scope">
						<span v-if="scope.row.lilv>0" style="color:limegreen">
							{{(scope.row.lilv*100).toFixed(2)}}%
						</span>
						<span v-else style="color:red">
							{{scope.row.lilv==null?"0":(scope.row.lilv*100).toFixed(2)}}%
						</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import format from "../../../utils/index.js"
	import {
		export2Excel
	} from '../../../common/js/util'
	export default {
		data() {
			return {
				date:new Date(),
				tableData: [],
				filter:{
					month:new Date().getFullYear().toString()
				},
				columns: [{
					title: '年份',
					key: 'month'
				}, {
					title: '门店数',
					key: 'storeNum'
				}, {
					title: '总营收',
					key: 'totalIncome'
				}, {
					title: '新客数',
					key: 'newCustomer'
				}, {
					title: '美团单数',
					key: 'meituanCustomer'
				}, {
					title: '抖音单数',
					key: 'douyinCustomer'
				}, {
					title: '总客数',
					key: 'totalCustomer'
				}, {
					title: '套餐数',
					key: 'taocanCustomer'
				}, {
					title: '套餐营收',
					key: 'taocanIncome'
				}, {
					title: '剪发单数',
					key: 'haircutCustomer'
				}, {
					title: '染护单数',
					key: 'colorCustomer'
				}, {
					title: '染护占比(%)',
					key: 'colorInAll'
				}, {
					title: '总成本',
					key: 'chengben'
				}, {
					title: '利润',
					key: 'yingli'
				}, {
					title: '净利率(%)',
					key: 'lilv'
				}]
			};
		},
		mounted() {
			this.getlist()
		},
		methods: {
			// 获取门店列表
			getlist() {
				this.$http.get("data/totalRevenueData?month=" + this.filter.month).then(
					function(res) {
						this.tableData = res.body.data
						this.tableData.map(ele=>{
							ele.colorInAll = ele.colorInAll/100
							ele.lilv =  ele.lilv/100
						})
					},
					function(err) {
						this.$message.error("请求失败")
					})
			},
			expro(){
				this.tableData.forEach(ele=>{
					if(ele.colorInAll ==null){
						ele.colorInAll = 0
					}
					if(ele.chengben ==null){
						ele.chengben = 0
					}
					if(ele.yingli ==null){
						ele.yingli = 0
					}
					if(ele.lilv ==null){
						ele.lilv = 0
					}
				})
				export2Excel(this.columns, this.tableData)
			}
		}
	};
</script>
<style lang="less" scoped>
	.topTitle{
			font-weight: blod;
			font-size: 22px;
			color: #707070;
		}
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}
</style>